import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  alpha,
} from '@mui/material';
import ExpandMoreRounded from '@mui/icons-material/ExpandMoreRounded';
import SummarizeRounded from '@mui/icons-material/SummarizeRounded';

interface ExecutiveSummaryProps {
  summary: string;
}

export default function ExecutiveSummary({ summary }: ExecutiveSummaryProps) {
  return (
    <Accordion
      disableGutters
      elevation={0}
      defaultExpanded
      sx={(t) => ({
        borderTop: `1px solid ${t.tokens.border.subtle}`,
        '&:before': { display: 'none' },
        bgcolor: alpha(t.palette.info.main, 0.03),
      })}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreRounded />}
        sx={{ minHeight: 40, px: 2.5, '& .MuiAccordionSummary-content': { my: 0.75 } }}
      >
        <SummarizeRounded sx={{ fontSize: 16, color: 'info.main', mr: 0.75 }} />
        <Typography variant="caption" fontWeight={700} color="text.secondary">
          Chain summary
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ px: 2.5, pt: 0, pb: 1.5 }}>
        <Typography variant="body2" sx={{ lineHeight: 1.65 }}>
          {summary}
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
}
